import React, { useEffect } from "react";
import { Link, Router } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { history } from "../../utils/routes";

import {
  talentsAec,
  choice,
  trainerAec,
  onboard,
  logout,
  plugAec,
  configurations,
} from "../../assets/icons/icons";

import {
  Body,
  CardsItens,
  Card,
  Icon,
  LabelItem,
  LabelUser,
  RowItens,
  LabelLogout,
  IconLink,
} from "./HomeStyle";

import * as urls from "../../utils/contants/urls";

const Home = () => {
  const doLogout = () => {
    localStorage.clear();
    window.location.href = "\\";
  };
  return (
    <Body>
      <div className="container">
        <RowItens>
          <LabelUser>
            <FormattedMessage id="homeOptions.welcome" />
          </LabelUser>
          <Link onClick={() => doLogout()}>
            <LabelLogout>
              <FormattedMessage id="homeOptions.logout" />
              <IconLink>{logout()}</IconLink>
            </LabelLogout>
          </Link>
        </RowItens>
        <div className="row">
          <div className="col-12">
            <CardsItens>
              <Card>
                <Link to={urls.PLUG_AEC}>
                  <Icon>{plugAec()}</Icon>
                  <LabelItem>
                    <FormattedMessage id="homeOptions.choiceModule" />
                  </LabelItem>
                </Link>
              </Card>
            </CardsItens>
          </div>
        </div>
      </div>
    </Body>
  );
};

export default Home;
